import { ReactComponent as DocumentsIcon } from "@assets/images/panel/dashboard/documents.svg";
import { ReactComponent as CockpitsIcon } from "@assets/images/panel/dashboard/cockpits.svg";
import { ReactComponent as CabinsIcon } from "@assets/images/panel/dashboard/cabins.svg";

import { pageRoutes } from "@pages";
import { hasAccess } from "@services/AccessCtrl";
import { PERMISSIONS } from "./permissions";
interface IMenu {
  title: string;
  path?: string;
  icon?: JSX.Element;
  hasAccess?: boolean;
  children?: IMenu[];
  showMenu: boolean;
}

const menus: IMenu[] = [
  {
    title: "Documents",
    path: pageRoutes.Documents,
    icon: <DocumentsIcon />,
    hasAccess: hasAccess(PERMISSIONS.DOCUMENT_TEMPLATE_LIST),
    children: [],
    showMenu: true,
  },
  {
    title: "Cockpits",
    path: pageRoutes.Cockpits,
    icon: <CockpitsIcon />,
    hasAccess: hasAccess(PERMISSIONS.COCKPIT_CREW_LIST),
    children: [],
    showMenu: true,
  },
  {
    title: "Cabins",
    path: pageRoutes.Cabins,
    icon: <CabinsIcon />,
    hasAccess: hasAccess(PERMISSIONS.CABIN_CREW_LIST),
    children: [],
    showMenu: true,
  },
  {
    title: "Assignment",
    path: pageRoutes.Assignment,
    hasAccess: hasAccess(PERMISSIONS.DOCUMENT_TEMPLATE_ASSIGN_JOB),
    children: [],
    showMenu: false,
  },
  {
    title: "Create Cockpit",
    path: pageRoutes.Create_Cockpit,
    hasAccess: hasAccess(PERMISSIONS.CREATE_COCKPIT_CREW),
    children: [],
    showMenu: false,
  },
  {
    title: "Create Cabin",
    path: pageRoutes.Create_Cabin,
    hasAccess: hasAccess(PERMISSIONS.CREATE_CABIN_CREW),
    children: [],
    showMenu: false,
  },
  {
    title: "Continue Create Cockpit",
    path: pageRoutes.Continue_Create_Cockpit,
    hasAccess: hasAccess(PERMISSIONS.EDIT_COCKPIT_CREW),
    children: [],
    showMenu: false,
  },
  {
    title: "Continue Create Cabin",
    path: pageRoutes.Continue_Create_Cabin,
    hasAccess: hasAccess(PERMISSIONS.EDIT_CABIN_CREW),
    children: [],
    showMenu: false,
  },
];

export { menus };
export type { IMenu };
